import { signInWithCustomToken } from "firebase/auth";
import React from "react";
import { auth, signOutFromApp } from "../core/firebaseInit";
import { log } from "../ui/log";
import { navigateGlobal } from "../ui/navigation/NavigateGlobal";
import { MessageType, type WebViewMessage } from "./webviewtypes";

export const signInWithToken = async (token: string) => {
  // If already signed in anonymously, sign out first to set the new state correct
  if (auth.currentUser?.isAnonymous) {
    await auth.signOut();
  }

  return signInWithCustomToken(auth, token)
    .then((_userCredential) => {
      log.network("User signed in signInWithCustomToken started");
    })
    .catch((error) => {
      const _errorCode = error.code;
      const _errorMessage = error.message;
    });
};

export function sendMessageToReactNative(message: WebViewMessage) {
  // @ts-expect-error
  if (window.ReactNativeWebView) {
    // @ts-expect-error
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }
}
// Inject JavaScript into the WebView to listen for postMessage events
export const useWebViewBridge = () => {
  React.useEffect(() => {
    const handleMessage = (event: { data: string; origin: string }) => {
      try {
        if (typeof event.data !== "string") {
          return;
        }

        const message = JSON.parse(event.data) as WebViewMessage;

        if (message.type === MessageType.SignInWithToken) {
          void signInWithToken(message.token);
        } else if (message.type === MessageType.Logout) {
          void signOutFromApp();
        } else if (message.type === MessageType.Ping) {
          sendMessageToReactNative(message);
        } else if (message.type === MessageType.Navigate) {
          if (message.moduleUid && message.planUid) {
            navigateGlobal("Module", {
              planUid: message.planUid,
              moduleUid: message.moduleUid,
            });
          } else if (message.planUid) {
            navigateGlobal("Plan", {
              planUid: message.planUid,
            });
          } else if (message.businessPlanUid && message.feedItemUid) {
            navigateGlobal("BusinessFeedItem", {
              businessUid: message.businessPlanUid,
              itemUid: message.feedItemUid,
            });
          } else if (message.businessPlanUid) {
            navigateGlobal("BusinessHome", {
              businessUid: message.businessPlanUid,
            });
          } else {
            navigateGlobal("Create");
          }
        }
      } catch (_e) {
        if (__DEV__) {
          // console.error("Got onMessageError", e);
        }
      }
    };

    // @ts-expect-error
    const w = window.__platform === "android" ? window.document : window;

    // @ts-expect-error
    w.addEventListener("message", handleMessage);

    // Clean up the event listener on component unmount
    return () => {
      // @ts-expect-error
      w.removeEventListener("message", handleMessage);
    };
  }, []);
};
